import React from "react";
import "./styles/Header.css";


const Header = () => {
  return (
    <div className="Header">
      <nav>
        <div className="leftnav">
          <a className="nav" href="/">
          💌RizzApi__
          </a>

        </div>
        <div className="rightnav">
          <a className= "randombtn nav"  href="http://rizzapi.vercel.app/random">RandomLine</a>
          <a className="nav" href="#about">Developer's Note.</a>
        </div>
      </nav>
    </div>
  );
};

export default Header;
